module.exports = __webpack_public_path__ + "img/IT0000630937690.f121df5f.png";